import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import styled from "styled-components";
import logo from '../images/LOLOO.png';


// Styled components for Navbar
const  NavbarContainer = styled.nav`
  display: flex;
  justify-content: space-between;
  align-items: center;
  background-color: white;
  padding: 1rem 2rem;
  position: relative;
  z-index: 10;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);
  height: 100px;

  /* For 992px and up, adjust padding */
  @media (min-width: 992px) {
  width:100%;
    padding: 1rem 3rem;
  }
     @media (min-width: 884px) {
  
   
  }

  /* For 1200px and up, adjust padding */
  @media (min-width: 1200px) {
    padding: 1rem 4rem;
  }
`;
export const Dropdown = styled.div`
  position: relative;
  cursor: pointer;
  color: gray;
  

  span {
    text-decoration: none;
    color: gray;
    text-decoration:bold;
    font-size: 1rem;

    &:hover {
      color: #ce8e04;
  }
`;

export const SubMenu = styled.div`
  position: absolute;
  top: 100%;
  left: 0;
  min-width: 180px;
  background-color: white;
  box-shadow: 0px 4px 10px rgba(0, 0, 0, 0.15);
  z-index: 999;
  border-radius: 4px;
  overflow: hidden;
`;

export const DropdownItem = styled.div`
  padding: 10px 15px;
  color: #333;
  font-weight: 500;
  white-space: nowrap;

  a {
    color: inherit;
    text-decoration: none;
    display: block;
  }

  &:hover {
    background-color: #f2f2f2;
  }
`;
const LogoContainer = styled.div`
  display: flex;
  align-items: center;
  margin-bottom: 12px;

  img {
    width: 150px;
    cursor: pointer;
  }
    @media (min-width: 884px) {
    font-size: 13px;
    margin-right: 12px;
  }

  @media (max-width: 480px) {
    img {
      width: 130px;
      margin-left: -50px;
      margin-top:px;
    }
  }

  /* Adjust logo size for larger screens */
  @media (min-width: 992px) {
    img {
      width: 180px;
    }
  }

  
`;

const TitleContainer = styled.div`
  color: black;
  
  margin-left: -55px;
  margin-top: 14px;

  /* Increase font size for larger screens */
  @media (min-width: 992px) {
    font-size: 18px;
  }
@media (max-width: 769px) {
font-size: 5px;
margin-left: -30px;  }
  @media (min-width: 1200px) {
    font-size: 2px;
  }
    @media (max-width: 480px) {
    
      
      margin-left: -50px;
      margin-bottom:6px;
      
    
  }
`;

const NavLinks = styled.ul`
  list-style: none;
  display: flex;
  margin: 0;
  margin-right:105px;
  

  /* Mobile menu styling */
  @media (max-width: 768px) {
    position: fixed;
    top: 150px;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.8);
    flex-direction: column;
    gap: 2rem;
    overflow: hidden;
    max-height: ${({ isOpen }) => (isOpen ? "100%" : "0")};
    transition: max-height 0.3s ease-in-out;
    z-index: 5;
  }

  /* Adjust spacing for larger screens */
  @media (min-width: 992px) {
    gap: 2rem;
  }

  @media (min-width: 1200px) {
    gap: 3rem;
  }
`;

const NavLinkItem = styled.li`

  margin:  0;
  &:before,
:after {
  content: '';
  background: #1890ff;
  width: 1px;
  position: absolute;
  top: 2px;
  bottom: 2px;
  left: 30%;
  opacity: 0;
  transition: all 0.3s linear;
}
 

  a {
    text-decoration: none;
    color: gray;
    text-decoration:bold;
    font-size: 1rem;

    &:hover {
      color: #ce8e04;
      
    }
  }
    

  @media (min-width: 769px) {
  
    margin-left: 2rem;
    font-size: 1rem; /* Adjust font size for desktops */
  }

  /* Increase font size for larger screens */
  @media (min-width: 992px) {
    font-size: 1.1rem;
  }

  @media (min-width: 1200px) {
    font-size: 1.2rem;
  }
`;

const Hamburger = styled.div`
  display: none;
  cursor: pointer;

  @media (max-width: 768px) {
    display: block;
    font-size: 1.5rem;
    color: #ce8e04;
  }
`;


const Navbar = () => {
  const [isOpen, setIsOpen] = useState(false);
  const navigate = useNavigate();
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);
const [dropdownOpen, setDropdownOpen] = useState(false);

   useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth <= 768);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const toggleMenu = () => setIsOpen(!isOpen);
  const closeMenu = () => setIsOpen(false);

  // Handle click on "Projects" item
  const handleProjectsClick = (e) => {
    if (isMobile) {
      if (!dropdownOpen) {
        e.preventDefault(); // prevent navigating
        setDropdownOpen(true); // show dropdown
      } else {
        navigate("/Projects"); // navigate on 2nd click
        setDropdownOpen(false);
        closeMenu();
      }
    }
  };

  return (
    <NavbarContainer>
      <LogoContainer>
        <img src={logo} alt="Logo" onClick={() => navigate('/')} />
        <TitleContainer>
          <div  className="smartstone-title">SMARTSTONE</div>
          <div className="sub-title">Marble Industry</div>
        </TitleContainer>
      </LogoContainer>
      
      <Hamburger onClick={toggleMenu}>
        {isOpen ? "✖" : "☰"}
      </Hamburger>

      <NavLinks isOpen={isOpen}>
        <NavLinkItem>
          <Link to="/" onClick={closeMenu}>HOME</Link>
        </NavLinkItem>
        <NavLinkItem>
          <Link to="About" onClick={closeMenu}>ABOUT US</Link>
        </NavLinkItem>
        <NavLinkItem>
          <Link to="Products" onClick={closeMenu}>PRODUCTS</Link>
        </NavLinkItem>
        {/* Dropdown */}
        <NavLinkItem
          onMouseEnter={() => setDropdownOpen(true)}
          onMouseLeave={() => setDropdownOpen(false)}
        >
          <Dropdown>
            <Link to="Projects" onClick={closeMenu}>PROJECTS</Link>
            
            {dropdownOpen && (
              <SubMenu>
                <DropdownItem><Link to="/projects/marble" onClick={closeMenu}>Marble Works</Link></DropdownItem>
                <DropdownItem><Link to="/projects/tiles" onClick={closeMenu}>Tiles Installation</Link></DropdownItem>
                <DropdownItem><Link to="/projects/cladding" onClick={closeMenu}>Wall Cladding</Link></DropdownItem>
              </SubMenu>
            )}
          </Dropdown>
        </NavLinkItem>

        <NavLinkItem>
          <Link to="Contact" onClick={closeMenu}>CONTACT US</Link>
        </NavLinkItem>
      </NavLinks>
    </NavbarContainer>
  );
};

export default Navbar;
